import { BaseApi } from '@/core/api/base.api'
import { Room } from "@/core/api/room.api";
import { roomTestbankService } from "@/core/service/room.testbank.service";

class TestbankApi extends BaseApi {
  constructor() {
    super()
    Room.Testbank = this

    Room.ready(e => {
      this._eventListen(this.#Events);

    });
  }

  #Events = {
  }

  async getTestbankList(params) {
    return (await roomTestbankService.getTestbankList(params)).data;
  }

  async createTestbank(params) {
    return (await roomTestbankService.createTestbank(params)).data;
  }

  async deleteTestbank(params) {
    return (await roomTestbankService.deleteTestbank(params)).data;
  }

  async getTestbankExamList(params) {
    return (await roomTestbankService.getTestbankExamList(params)).data;
  }

  async createTestbankExam(params) {
    return (await roomTestbankService.createTestbankExam(params)).data;
  }

  async getTestbankExam(params) {
    return (await roomTestbankService.getTestbankExam(params)).data;
  }

  async deleteTestbankExam(params) {
    return (await roomTestbankService.deleteTestbankExam(params)).data;
  }

  async editTestbankExam(params) {
    return (await roomTestbankService.editTestbankExam(params)).data;
  }

  async getTestbankExamHistoryList(params) {
    return (await roomTestbankService.getTestbankExamHistoryList(params)).data;
  }

  async getTestbankExamHistory(params) {
    return (await roomTestbankService.getTestbankExamHistory(params)).data;
  }
}

export const Testbank = new TestbankApi();
